import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { useForm } from "react-hook-form";

import { ContactGenre, ContactMessageSenderType } from "@/lib/gql/__generated__/graphql";

import { contactCreateInputZodSchema } from "../../schema/validation-schema";

import type { ContactCreateInputZodSchemaType } from "../../schema";
import type { UseFormReturn } from "react-hook-form";

type Props = {
	hotelID: string;
};

export const useContactForm = ({ hotelID }: Props): { form: UseFormReturn<ContactCreateInputZodSchemaType> } => {
	const defaultValues: ContactCreateInputZodSchemaType = {
		contactGenre: ContactGenre.HostSettings,
		hotelID,
		hostReplyToMail: "",
		title: "",
		reservationID: "",
		message: {
			senderType: ContactMessageSenderType.Host,
			message: "",
			relatedURLs: [],
			images: [],
		},
	} satisfies ContactCreateInputZodSchemaType;

	const form: UseFormReturn<ContactCreateInputZodSchemaType> = useForm<ContactCreateInputZodSchemaType>({
		mode: "onChange",
		resolver: zodResolver(contactCreateInputZodSchema),
		defaultValues,
	});

	// form 全体がメモ化される予定らしいので、`trigger` だけが `useEffect` の依存関係に含まれるようにしている
	// @docs https://react-hook-form.com/docs/useform#:~:text=useForm%20return%20and%20useEffect%20dependencies
	const { trigger, watch, resetField } = form;
	useEffect(() => {
		trigger();
	}, [trigger]);

	// ジャンルが変更されたら、メッセージと予約番号をリセットする
	const contactGenre = watch("contactGenre");
	useEffect(() => {
		resetField("reservationID");

		if (contactGenre === ContactGenre.GuestReservation) {
			trigger("reservationID");
		}
	}, [contactGenre, resetField, trigger]);

	return { form };
};
